'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = require('react-transition-group');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _slideTransitionLocal = require('./slide-transition.local.css');

var _slideTransitionLocal2 = _interopRequireDefault(_slideTransitionLocal);

var _panelLocal = require('./panel.local.css');

var _panelLocal2 = _interopRequireDefault(_panelLocal);

var _header = require('./header');

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Panel = function (_Component) {
  _inherits(Panel, _Component);

  function Panel(props) {
    _classCallCheck(this, Panel);

    var _this = _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));

    _this.toggleSection = function (e) {
      if (_this.props.toggleCollapse) {
        _this.props.toggleCollapse(e);

        return;
      }

      _this.setState(function (prevState) {
        return {
          isCollapsed: !prevState.isCollapsed
        };
      });
    };

    _this.state = {
      isCollapsed: props.defaultCollapsed
    };
    return _this;
  }

  _createClass(Panel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          title = _props.title,
          action = _props.action,
          disableCollapse = _props.disableCollapse,
          className = _props.className;
      var isCollapsed = this.props.isCollapsed || this.state.isCollapsed;
      return _react2.default.createElement('section', {
        className: (0, _classnames2.default)(_panelLocal2.default.accentPanel, className)
      }, title && _react2.default.createElement(_header2.default, {
        disableCollapse: disableCollapse,
        isCollapsed: isCollapsed,
        toggleCollapse: this.toggleSection,
        action: action
      }, title), _react2.default.createElement(_reactTransitionGroup.CSSTransitionGroup, {
        transitionName: _slideTransitionLocal2.default,
        transitionEnterTimeout: 300,
        transitionLeaveTimeout: 300
      }, isCollapsed ? null : _react2.default.createElement('div', {
        className: _panelLocal2.default.content
      }, children)));
    }
  }]);

  return Panel;
}(_react.Component);

Panel.propTypes = {
  /**
   * Content inside the panel
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * Title to show at the top of the Panel
   */
  title: _propTypes2.default.node,

  /**
   * Optionally add a right-side CTA
   */
  action: _propTypes2.default.shape({
    icon: _propTypes2.default.string,
    label: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    id: _propTypes2.default.any
  }),

  /**
   * Force panel to stay open always
   */
  disableCollapse: _propTypes2.default.bool,

  /**
   * Set the panel to collapsed by default
   */
  defaultCollapsed: _propTypes2.default.bool,

  /**
   * Allows parent components to control the collapse
   */
  isCollapsed: _propTypes2.default.bool,

  /**
   * Callback function when panel header is clicked.
   */
  toggleCollapse: _propTypes2.default.func,

  /**
   * Additional className
   */
  className: _propTypes2.default.string
};
Panel.defaultProps = {
  disableCollapse: false,
  defaultCollapsed: false,
  action: {}
};
exports.default = Panel;